<template>
  <HeadingLv1 :text="'利用規約・個人情報保護方針'" />
  <div class="terms">
    <div class="u-containar">
      <HeadingLv3 :text="'マイナビRESIDENT  利用規約'" />
      <template v-for="term in termData" :key="term.title">
        <HeadingLv4 :text="term.title" />
        <div v-html="term.html"></div>
      </template>
      <div class="right" v-html="termDate"></div>
      <BackTo label="戻る" link="/" />
    </div>
  </div>
</template>

<script lang="ts">
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import BackTo from '@/components/block/BackTo.vue'

export const termData = [
  {
    title: '第1条（マイナビRESIDENT）',
    html: `      <p>
        「マイナビRESIDENT」（以下「本サービス」といいます）とは、株式会社マイナビ（以下「当社」といいます）が提供するインターネット上の医学生・初期研修医向けの情報サイト（<a
          href="https://resident.mynavi.jp/"
          >https://resident.mynavi.jp/</a
        >）、当該サイトに付随するメール配信等の情報提供支援サービス、およびその他各種情報提供サービスの総称をいいます。
      </p>`
  },
  {
    title: '第2条（サービスの利用）',
    html: `
      <ol class="numList">
        <li>
          本サービスの利用者（以下「利用者」といいます）は、本サービスの利用にあたって本規約および「個人情報の取り扱いについて（マイナビRESIDENT）」の内容をすべて承諾したものとみなされます。不承諾の意思表示は、本サービスを利用しないことをもってのみ認められるものとします。
        </li>
        <li>
          利用者は、自己の意思および責任をもって本サービスを利用するものとします。
        </li>
      </ol>`
  },
  {
    title: '第3条（会員）',
    html: `      <ol class="numList">
        <li>
          会員（以下「会員」といいます）とは、利用者のうち、初期研修や専門研修の情報収集を行う医学生・初期研修医で、個人を特定できる情報（以下「個人情報」といいます）を本サービスに登録し、当社が会員となることを承認した方をいいます。
        </li>
        <li>
          会員は、個人情報および活動情報を本サービスに登録することにより、本サービスのうち会員サービスの利用が可能となります（登録した情報を「登録情報」といいます）。会員は、登録情報について、その内容に関する責任を負うものとします。
        </li>
        <li>
          会員は、本サービスの会員専用ページ（以下「会員専用ページ」といいます）において、会登録情報をいつでも確認・修正・削除することができます。
        </li>
        <li>
          当社は、会員が本規約に違反したと当社が判断した場合、当該会員への事前の通知なく、当該会員の登録情報を修正・削除することができるものとします。
        </li>
        <li>
          会員は、会員ID・パスワードを自己の責任において使用・管理し、いかなる場合もそれらを第三者に使用させ、または譲渡してはならないものとします。
        </li>
        <li>
          会員は、登録情報やその他の情報を自己の責任において保存するものとし、当社は、保存義務を負わないものとします。
        </li>
      </ol>`
  },
  {
    title: '第4条（禁止行為）',
    html: `
      <p>
        利用者は、本サービスにおいて、次の各号に定める行為またはそれに該当するおそれのある行為をしないものとします。
      </p>
      <ol class="numList -paren">
        <li>重複もしくは虚偽の情報、または他者の情報を登録する行為</li>
        <li>
          当社または第三者の著作権等の知的財産権、プライバシー、名誉、肖像権等の権利を侵害する行為
        </li>
        <li>当社または第三者を差別、批判、攻撃、または誹謗中傷等する行為</li>
        <li>当社または第三者の業務の運営を妨げ、または信用を毀損する行為</li>
        <li>
          当社または第三者に対する暴力的な言動、不当な要求またはそれらに類する行為
        </li>
        <li>当社または第三者に対して、不利益を与える行為</li>
        <li>営業活動または営利を目的とした情報を提供する行為</li>
        <li>政治活動、選挙活動、宗教活動またはそれらに類する行為</li>
        <li>法令違反行為、犯罪行為、または公序良俗に反する行為</li>
        <li>その他、当社が不適切と判断する行為</li>
      </ol>`
  },
  {
    title: '第5条（免責）',
    html: `      <ol class="numList">
        <li>
          当社は、利用者または第三者が本サービスの利用により被ったいかなる損害に対しても、当社の責めに帰する場合を除き、責任を負わないものとします。なお、当社が責任を負う場合であっても、当社に故意または重大な過失がない限り、当社が責任を負う範囲は、直接かつ現実に生じた通常の損害に限られるものとします。
        </li>
        <li>
          当社は、通常講ずるべきウイルス対策では防止できないウイルス被害、天変地異による被害、予防措置を講じたにもかかわらず発生したシステム障害、その他当社の責めによらない事由による被害が生じた場合、一切の責任を負わないものとします。
        </li>
        <li>
          本サービスにおいて提供される情報（医療機関等の採用情報、広告その他第三者により提供される情報）の内容に関して、当社は、一切の保証を行わないものとし、利用者はこれを承諾のうえ、自己の責任において当該情報を利用するものとします。
        </li>
        <li>
          利用者が本サービスの利用により第三者に対して損害を生じさせた場合、利用者は、自己の責任においてこれを解決するものとし、当社は一切の責任も負わないものとします。
        </li>
        <li>
          当社は、本サービスの利用における利用者の就職・転職活動の結果の確実性、その他の効果・結果について、一切の保証を行わないものとします。
        </li>
      </ol>`
  },
  {
    title: '第6条（知的財産権）',
    html: `<ol class="numList">
        <li>
          本サービスに含まれるすべてのコンテンツの知的財産権は、当社に帰属するものとします。ただし、情報提供元または情報提供元から委託を受けた者が作成した原稿・写真・動画等については、この限りではありません。
        </li>
        <li>
          当社は、会員に対して、各種のアンケート調査、キャンペーン、モニター応募等を実施することがあります。当社は、それらを通じて、会員が本サービス上に投稿した意見や情報等の内容を、当社発行の情報誌、雑誌やWeb上の著作物等に転載することができるものとし、会員は、これをあらかじめ承諾するものとします。
        </li>
        <li>
          前項に基づき、当社が加工・作成した情報等に関する著作権、その他一切の権利は、当社に帰属するものとします。
        </li>
      </ol>`
  },
  {
    title: '第7条（反社会的勢力の排除）',
    html: ` <ol class="numList">
        <li>
          利用者は、次の者に該当しないこと、および今後もこれに該当しないことを保証し、利用者がこれに該当した場合、または該当していたことが判明した場合には、当社は別段の催告を要せず、直ちに本サービスの利用を停止させることができるものとします。<br />暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団、その他これらに準ずる者（以下これらを「反社会的勢力」といいます）であること。
        </li>
        <li>
          <span
            >利用者が次の各号のいずれかに該当した場合、当社は、別段の催告を要せず、直ちに本サービスの利用を停止させることができるものとします。</span
          >
          <ol class="numList -paren">
            <li>
              当社に対して脅迫的な言動をすること、もしくは暴力を用いること、または当社の名誉・信用を毀損する行為を行うこと。
            </li>
            <li>偽計または威力を用いて当社の業務を妨害すること。</li>
            <li>当社に対して法的な責任を超えた不当な要求をすること。</li>
            <li>反社会的勢力である第三者をして前三号の行為を行わせること。</li>
          </ol>
        </li>
      </ol>`
  },
  {
    title: '第8条（会員の退会・除名）',
    html: `      <ol class="numList">
        <li>
          会員は、会員専用ページより、本サービスから自由に退会ができるものとします。
        </li>
        <li>
          当社は、会員が本規約に違反していると判断した場合、当該会員への事前の通知なく、会員からの除名、または本サービスの利用を一時停止させることができます。
        </li>
        <li>
          当社は、会員が最後に会員専用ページにログインした日から3年間に一度もログインがない場合、当該会員への事前の通知なく、退会処理を行う場合があります。
        </li>
      </ol>`
  },
  {
    title: '第9条（損害賠償）',
    html: `      <p>
        利用者が本規約に違反し、当社に対して損害を与えた場合、利用者は、当社に生じた一切の損害について、賠償義務を負うものとします。
      </p>`
  },
  {
    title: '第10条（サービスの変更等）',
    html: `      <ol class="numList">
        <li>
          当社は、利用者への事前の通知なく、本サービスの変更または一時的な中断を行うことがあります。
        </li>
        <li>
          当社は、1ヶ月の予告期間をもって利用者に通知のうえ、本サービスの提供を長期的に中断または終了することができます。
        </li>
      </ol>`
  },
  {
    title: '第11条（利用規約の変更）',
    html: `      <ol class="numList">
        <li>
          <span
            >当社は、次の各号に定める場合、利用者の同意を得ることなく、本規約を変更することができるものとします。</span
          >
          <ol class="numList -paren">
            <li>本規約の変更が、利用者の一般の利益に適合する場合。</li>
            <li>
              本規約の変更が、本サービスの目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容、その他の変更にかかる事情に照らして合理的なものである場合。
            </li>
          </ol>
        </li>
        <li>
          当社は、前項による本規約の変更にあたり、変更実施日の1ヶ月前までに、本規約を変更する旨および変更後の本規約の内容を本サービス上に掲示、または利用者に電子メールにより通知するものとします。
        </li>
      </ol>`
  },
  {
    title: '第12条（分離条項）',
    html: `
      <p>
        本規約の一部の効力が、法令や確定判決により無効とされた場合であっても、その他の条項は引き続き効力を有するものとします。
      </p>`
  },

  {
    title: '第13条（準拠法・合意管轄）',
    html: `      <p>
        本規約は日本法を準拠法とし、本規約に関わる一切の紛争については、訴額に応じて東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p`
  }
]
export const termDate = `
<p>
          付則
          <br />
          2014年2月3日制定
          <br />
          2014年10月20日改定
          <br />
          2015年1月19日改定
          <br />
          2015年10月1日改定
          <br />
          2017年2月23日改定
          <br />
          2020年12月1日全面改定
        </p>
        <p>
          お問い合わせ先：マイナビRESIDENT運営事務局
          <br />
          <a href="mailto:resident-support@mynavi.jp"
            >resident-support@mynavi.jp</a
          >
        </p>`

export default {
  name: 'Terms',

  components: {
    HeadingLv1,
    HeadingLv3,
    HeadingLv4,
    BackTo
  },
  setup() {
    return {
      termData,
      termDate
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.terms {
  ::v-deep(.headingLv4) {
    margin-bottom: 3px;
    @include mixins.media() {
      margin-bottom: 14px;
    }
  }
  ::v-deep(p, li) {
    font-size: 14px;
    line-height: 1.7;
    letter-spacing: 0;
    > a {
      color: var.$color-main-text;
    }
  }

  ::v-deep(p + .numList) {
    margin-top: 14px;
  }

  ::v-deep(.numList) {
    margin-left: 9px;
    padding-left: 9px;
    li {
      counter-increment: cnt;
      text-indent: -9px;
      &::before {
        content: counter(cnt) '.';
        display: inline-block;
        margin-right: 7px;
      }
      + li {
        margin-top: 14px;
      }
      > ol {
        margin-top: 14px;
      }
    }

    &.-paren {
      margin-left: 12px;
      padding-left: 12px;
      li {
        text-indent: -12px;
        counter-increment: cnnt;
      }
      li::before {
        content: '(' counter(cnnt) ')';
        display: inline-block;
        margin-right: 7px;
      }
    }
  }
  ::v-deep(.right) {
    text-align: right;
    @include mixins.media() {
      margin-top: 44px;
    }
    p {
      margin-top: 14px;
      @include mixins.media() {
        margin-top: 20px;
      }
    }
    margin-bottom: 37px;
  }
}
</style>
